(()=>{
  const drawer=document.querySelector('[data-cart-drawer]');
  const overlay=document.querySelector('[data-cart-overlay]');
  const content=document.querySelector('[data-cart-content]');
  const footer=document.querySelector('[data-cart-footer]');
  const config=window.LumaSenseConfig||{};
  const money=(cents,currency)=>new Intl.NumberFormat('tr-TR',{style:'currency',currency:currency||config.currency||'TRY'}).format((Number(cents)||0)/100);
  const escapeHTML=value=>String(value??'').replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  const setCount=count=>document.querySelectorAll('[data-cart-count]').forEach(el=>el.textContent=count);
  const open=()=>{if(!drawer)return;drawer.classList.add('is-open');overlay?.classList.add('is-open');drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden';refreshCart()};
  const close=()=>{drawer?.classList.remove('is-open');overlay?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');document.body.style.overflow=''};
  const progressHTML=cart=>{
    const threshold=Number(config.shippingThreshold)||0;
    if(!threshold)return '';
    const total=cart.total_price/100, remaining=Math.max(0,threshold-total),pct=Math.min(100,total/threshold*100);
    const message=remaining>0?`${money(remaining*100,cart.currency)} daha ekleyin, kargo avantajına ulaşın.`:'Kargo avantajı tamamlandı. Güzel seçim!';
    return `<div class="cart-progress"><div class="cart-progress__copy"><span>${message}</span><span>${Math.round(pct)}%</span></div><div class="cart-progress__track"><div class="cart-progress__fill" style="width:${pct}%"></div></div></div>`;
  };
  const itemHTML=(item)=>{
    const image=item.image?`<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">`:`<div class="cart-line__placeholder"></div>`;
    return `<article class="cart-line">${image}<div><h3>${escapeHTML(item.product_title)}</h3><small>${escapeHTML(item.variant_title==='Default Title'?'':item.variant_title||'')}</small><div class="cart-line__price">${money(item.final_line_price,item.currency)}</div><div class="cart-line__controls"><div class="cart-qty"><button type="button" data-qty="-1" data-key="${escapeHTML(item.key)}" aria-label="Adedi azalt">−</button><span>${item.quantity}</span><button type="button" data-qty="1" data-key="${escapeHTML(item.key)}" aria-label="Adedi artır">+</button></div><button class="cart-remove" type="button" data-remove="${escapeHTML(item.key)}">Kaldır</button></div></div><div class="cart-line__price">${money(item.final_line_price,item.currency)}</div></article>`;
  };
  async function loadRecommendations(cart){
    const target=document.querySelector('[data-cart-recommendations]');
    if(!target||!cart.items.length)return;
    const seen=new Set(cart.items.map(i=>Number(i.product_id)));
    let products=[];
    try{
      const ids=cart.items.map(i=>i.product_id);
      const data=await fetch(`/recommendations/products.json?product_id=${ids[0]}&limit=6&intent=related`,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null);
      if(data?.products)products=data.products;
    }catch(e){}
    if(!products.length&&config.recommendationCollection){
      try{const data=await fetch(`/collections/${encodeURIComponent(config.recommendationCollection)}/products.json?limit=12`,{headers:{Accept:'application/json'}}).then(r=>r.ok?r.json():null);if(data?.products)products=data.products;}catch(e){}
    }
    products=products.filter(p=>!seen.has(Number(p.id))).slice(0,2);
    if(!products.length){target.hidden=true;return}
    target.hidden=false;
    target.innerHTML=`<h3>İyi giden seçiminizi tamamlayın</h3><div class="cart-recommendations__list">${products.map(p=>{
      const v=p.variants?.find(x=>x.available!==false)||p.variants?.[0];if(!v)return '';
      const image=p.featured_image||p.images?.[0]||'';
      return `<article class="cart-recommendation">${image?`<img src="${escapeHTML(image)}" alt="${escapeHTML(p.title)}" loading="lazy">`:'<span></span>'}<div><strong>${escapeHTML(p.title)}</strong><span>${money(Number(v.price),cart.currency)}</span></div><button type="button" data-recommend-add="${v.id}">Ekle +</button></article>`;
    }).join('')}</div>`;
  }
  async function refreshCart(){
    if(!content)return;
    try{
      const cart=await fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
      setCount(cart.item_count);
      if(!cart.item_count){
        content.innerHTML=`<div class="cart-empty"><h3>Sepetiniz henüz boş.</h3><p>Yaşam alanınızda küçük bir fark yaratacak akıllı aydınlatmayı keşfedin.</p><a class="button" href="/collections/all">Ürünleri keşfet</a></div>`;
        footer.innerHTML='';return;
      }
      content.innerHTML=progressHTML(cart)+`<div class="cart-items">${cart.items.map(itemHTML).join('')}</div><div class="cart-recommendations" data-cart-recommendations hidden></div>`;
      footer.innerHTML=`<p class="cart-note">${escapeHTML(config.cartNote||'Siparişinizi tamamlamadan önce bilgilerinizi kontrol edebilirsiniz.')}</p><div class="cart-total"><span>Ara toplam</span><span>${money(cart.total_price,cart.currency)}</span></div><a class="button cart-checkout" href="/checkout">Güvenli ödemeye geç&nbsp; →</a><div class="cart-safe"><span><svg viewBox="0 0 24 24"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Güvenli ödeme</span><span>✓ Sipariş takibi</span><span>♡ Destek</span></div>`;
      loadRecommendations(cart);
    }catch(e){content.innerHTML='<p class="cart-loading">Sepet şu anda yüklenemedi. Lütfen yeniden deneyin.</p>';}
  }
  async function changeItem(key,quantity){
    try{await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity})});await refreshCart();}
    catch(e){console.error('Cart update failed',e);}
  }
  document.addEventListener('click',async e=>{
    if(e.target.closest('[data-cart-open]')){e.preventDefault();open();}
    if(e.target.closest('[data-cart-close]')||e.target===overlay)close();
    if(e.target.closest('[data-mobile-toggle]'))document.querySelector('[data-mobile-nav]')?.classList.toggle('is-open');
    const qty=e.target.closest('[data-qty]');if(qty){const line=qty.closest('.cart-line');const current=Number(line?.querySelector('.cart-qty span')?.textContent||1);const key=qty.dataset.key;await changeItem(key,Math.max(0,current+Number(qty.dataset.qty)));}
    const remove=e.target.closest('[data-remove]');if(remove)await changeItem(remove.dataset.remove,0);
    const add=e.target.closest('[data-recommend-add]');if(add){add.disabled=true;add.textContent='Ekleniyor';try{const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(add.dataset.recommendAdd),quantity:1})});if(!r.ok)throw new Error('add');await refreshCart();}catch(err){add.disabled=false;add.textContent='Tekrar dene';}}
    const thumb=e.target.closest('[data-gallery-thumb]');if(thumb){const main=document.querySelector('.product-gallery .product-main-image img');if(main){main.src=thumb.dataset.imageSrc;main.srcset='';main.alt=thumb.dataset.imageAlt||main.alt;const lightboxImage=document.querySelector('#productLightboxImage');if(lightboxImage){lightboxImage.src=thumb.dataset.imageSrc;lightboxImage.alt=main.alt;}document.querySelectorAll('[data-gallery-thumb]').forEach(x=>x.classList.remove('is-active'));thumb.classList.add('is-active');}}
    if(e.target.closest('[data-product-zoom]')){const dialog=document.querySelector('[data-product-lightbox]');const main=document.querySelector('#productMainImage');const zoom=document.querySelector('#productLightboxImage');if(dialog&&main&&zoom){zoom.src=main.currentSrc||main.src;zoom.alt=main.alt;dialog.showModal();}}
    if(e.target.closest('[data-lightbox-close]'))document.querySelector('[data-product-lightbox]')?.close();
  });
  document.addEventListener('submit',async e=>{
    const form=e.target.closest('form[data-product-form]');if(!form)return;
    if(config.cartEnabled===false)return;
    e.preventDefault();const btn=form.querySelector('[type="submit"]');const original=btn?.textContent;
    if(btn){btn.disabled=true;btn.textContent='Sepete ekleniyor…';}
    try{const response=await fetch('/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});if(!response.ok){const error=await response.json();throw new Error(error.description||'Ürün sepete eklenemedi.');}if(btn)btn.textContent='Sepete eklendi ✓';open();}
    catch(err){console.error(err);form.submit();}
    finally{if(btn)setTimeout(()=>{btn.disabled=false;btn.textContent=original||'Sepete ekle';},1400);}
  });
  document.addEventListener('change',e=>{
    const select=e.target.closest('[data-variant-select]');if(!select)return;
    const option=select.selectedOptions[0];if(!option)return;
    const cents=Number(option.dataset.priceCents||0),compare=Number(option.dataset.compareCents||0);
    const priceWrap=document.querySelector('[data-product-price-wrap]');
    const button=document.querySelector('form[data-product-form] [type="submit"]');
    if(priceWrap){priceWrap.innerHTML=compare>cents?`<span class="price price__sale">${money(cents,config.currency)} <del>${money(compare,config.currency)}</del></span>`:`<span class="price">${money(cents,config.currency)}</span>`;}
    if(button){button.textContent=`Sepete ekle · ${money(cents,config.currency)}`;button.disabled=option.disabled;}const stickyPrice=document.querySelector('.strip-sticky-buy__price');if(stickyPrice)stickyPrice.textContent=money(cents,config.currency);
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){close();document.querySelector('[data-product-lightbox]')?.close();}});
  window.LumaSenseOpenCart=open;
})();


// LumaSense Işık Rehberi: guided, catalog-aware product finder (no external AI service).
(()=>{
  const root=document.querySelector('[data-light-guide]');
  if(!root || window.LumaSenseConfig?.guideEnabled===false) return;
  const panel=root.querySelector('[data-guide-panel]');
  const body=root.querySelector('[data-guide-body]');
  const launcher=root.querySelector('[data-guide-open]');
  const closeBtn=root.querySelector('[data-guide-close]');
  const cfg=window.LumaSenseConfig||{};
  const escapeHTML=value=>String(value??'').replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
  const state={step:0,answers:{},products:null};
  const questions=[
    {key:'area',title:'Işığı en çok nerede kullanacaksınız?',hint:'Kullanım alanınıza göre ürünleri öne çıkaralım.',options:[
      ['Koridor','⌂','koridor'],['Merdivenler','↗','merdiven'],['Mutfak tezgâhı','▤','mutfak'],['Çalışma masası','▤','calisma'],['Gardırop / dolap içi','▤','dolap'],['Başka bir alan','✦','diger']]},
    {key:'behavior',title:'Nasıl bir aydınlatma arıyorsunuz?',hint:'Öncelikli kullanım şeklinizi seçin.',options:[
      ['Hareket algılayınca otomatik yansın','◉','hareket'],['Üç ışık tonu arasında geçiş yapayım','☼','renk-modu'],['Yumuşak, ambiyans ışığı olsun','✧','ambiyans']]},
    {key:'priority',title:'Sizin için en önemli özellik hangisi?',hint:'Size en çok değer katacak özelliği seçin.',options:[
      ['Şarj edilebilir olması','↻','sarjli'],['Mıknatıslı ve çıkarılabilir montaj','⌁','miknatisli'],['Kompakt ve ince tasarım','◌','kompakt'],['Birden fazla ışık modu','✦','cok-yonlu']]}
  ];
  const tagMap={
    area:{koridor:'rehber-koridor',merdiven:'rehber-merdiven',mutfak:'rehber-mutfak',calisma:'rehber-calisma-alani',dolap:'rehber-dolap',diger:'rehber-genel'},
    behavior:{hareket:'rehber-hareket-sensoru','renk-modu':'rehber-uc-isik-modu',ambiyans:'rehber-ambiyans'},
    priority:{sarjli:'rehber-sarjli',miknatisli:'rehber-miknatisli',kompakt:'rehber-kompakt','cok-yonlu':'rehber-cok-yonlu'}
  };
  const open=()=>{
    const waRoot=document.querySelector('[data-whatsapp-assistant]');
    const waPanel=waRoot?.querySelector('[data-wa-panel]');
    const waLauncher=waRoot?.querySelector('[data-wa-open]');
    if(waPanel&&!waPanel.hidden){waPanel.hidden=true;waLauncher?.setAttribute('aria-expanded','false');}
    panel.hidden=false;launcher.setAttribute('aria-expanded','true');root.classList.add('is-open');
  };
  const close=()=>{panel.hidden=true;launcher.setAttribute('aria-expanded','false');root.classList.remove('is-open');launcher.focus();};
  const start=()=>{state.step=0;state.answers={};renderQuestion();};
  function renderWelcome(){body.innerHTML=`<div class="light-guide__welcome"><p>${escapeHTML(cfg.guideIntro||'Birkaç kısa soruyla yaşam alanınıza en uygun LumaSense ürününü birlikte keşfedelim.')}</p><div class="light-guide__welcome-note"><span>✧</span><span>Yaklaşık 30 saniye · 3 kısa soru</span></div><button class="button light-guide__start" type="button" data-guide-start>Başlayalım <span aria-hidden="true">→</span></button></div>`;}
  function renderQuestion(){
    const q=questions[state.step];
    body.innerHTML=`<div class="light-guide__progress">${questions.map((_,i)=>`<span class="${i<=state.step?'is-done':''}"></span>`).join('')}</div><div class="light-guide__step-count">ADIM ${state.step+1} / ${questions.length}</div><h3 class="light-guide__question">${q.title}</h3><p class="light-guide__hint">${q.hint}</p><div class="light-guide__options">${q.options.map(([label,icon,value])=>`<button class="light-guide__option" type="button" data-guide-answer="${value}"><span class="light-guide__option-icon">${icon}</span><span>${label}</span><span class="light-guide__option-arrow">›</span></button>`).join('')}</div><div class="light-guide__nav"><button class="light-guide__back" type="button" data-guide-back>${state.step===0?'Girişe dön':'← Önceki soru'}</button><button class="light-guide__skip" type="button" data-guide-skip>Bu soruyu geç</button></div>`;
  }
  const norm=s=>String(s||'').toLocaleLowerCase('tr-TR').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ı/g,'i');
  async function getProducts(){
    if(state.products)return state.products;
    const response=await fetch('/collections/all/products.json?limit=50',{headers:{Accept:'application/json'}});
    if(!response.ok)throw new Error('catalog');
    const data=await response.json();state.products=Array.isArray(data.products)?data.products:[];return state.products;
  }
  function scoreProduct(product){
    const tags=(Array.isArray(product.tags)?product.tags:String(product.tags||'').split(',')).map(x=>norm(x.trim()));
    const haystack=norm([product.title,product.product_type,product.body_html].join(' '));
    let score=0,matched=0;
    Object.entries(state.answers).forEach(([key,value])=>{
      if(!value)return;
      const tag=tagMap[key]?.[value];
      if(tag && tags.includes(norm(tag))){score+=20;matched++;}
      const words={
        koridor:['koridor','hol'],merdiven:['merdiven','basamak'],mutfak:['mutfak','tezgah','tezgâh'],calisma:['çalışma masası','masa'],dolap:['dolap','gardrop'],diger:[],
        hareket:['hareket','sensor','sensör','otomatik'],'renk-modu':['üç ışık','3 ışık','üç renk','3 renk','beyaz','sarı','gün ışığı'],ambiyans:['ambiyans','dekoratif'],
        sarjli:['sarj','şarj','usb'],miknatisli:['mıknatıs','manyetik','metal plaka'],kompakt:['kompakt','30 cm','ince tasarım'], 'cok-yonlu':['çok yönlü','üç mod','ışık modu']
      }[value]||[];
      if(words.some(w=>haystack.includes(norm(w)))){score+=4;matched++;}
    });
    return {...product,_guideScore:score,_guideMatches:matched};
  }
  const availableVariant=p=>p.variants?.find(v=>v.available!==false)||p.variants?.[0]||null;
  const formatProductPrice=p=>{const raw=Number(availableVariant(p)?.price??0);return new Intl.NumberFormat('tr-TR',{style:'currency',currency:cfg.currency||'TRY'}).format(raw);};
  function reasonFor(p){
    if(p._guideMatches>=3)return 'Seçtiğiniz alan ve özelliklerle güçlü bir eşleşme.';
    if(p._guideMatches===2)return 'Tercihlerinizle iyi eşleşen bir seçenek.';
    if(p._guideMatches===1)return 'İhtiyaçlarınızdan en az biriyle örtüşen bir seçenek.';
    return 'Mağazamızda şu anda bulunan ürünler arasından keşfedebileceğiniz seçenek.';
  }
  async function renderResults(){
    body.innerHTML='<div class="light-guide__loading"><div class="light-guide__spinner"></div>Size uygun ürünleri seçiyoruz…</div>';
    try{
      const products=await getProducts();
      const ranked=products.map(scoreProduct).sort((a,b)=>b._guideScore-a._guideScore).slice(0,3);
      if(!ranked.length){body.innerHTML='<div class="light-guide__none">Şu anda öneri oluşturabileceğimiz bir ürün bulamadık. Ürünlerimizi inceleyebilir veya bizimle iletişime geçebilirsiniz.</div><a class="button" href="/collections/all">Tüm ürünleri gör</a><button class="light-guide__restart" data-guide-restart>Yanıtlarımı değiştir</button>';return;}
      const intro=ranked.length===1?'Yanıtlarınıza göre mağazamızdaki mevcut ürünü öne çıkardık. Yeni ürünler eklendikçe öneriler de çeşitlenecek.':'Yanıtlarınıza en yakın seçenekleri sizin için sıraladık.';
      body.innerHTML=`<div class="light-guide__progress">${questions.map(()=>'<span class="is-done"></span>').join('')}</div><div class="light-guide__step-count">SİZE ÖZEL ÖNERİ</div><h3 class="light-guide__question">Işığınız bulundu ✨</h3><p class="light-guide__result-intro">${intro}</p>${ranked.map(p=>{
        const img=p.featured_image||p.images?.[0]?.src||p.images?.[0]||'';
        const url='/products/'+encodeURIComponent(p.handle);
        const variant=availableVariant(p);
        return `<article class="light-guide__product">${img?`<img src="${escapeHTML(img)}" alt="${escapeHTML(p.title)}" loading="lazy">`:'<div class="light-guide__product-placeholder"></div>'}<div class="light-guide__product-copy"><strong>${escapeHTML(p.title)}</strong><p>${reasonFor(p)}</p><span class="light-guide__product-price">${formatProductPrice(p)}</span><div class="light-guide__product-actions"><a class="light-guide__product-link" href="${url}">Ürünü incele →</a>${variant&&variant.available!==false?`<button class="light-guide__add" type="button" data-guide-add="${Number(variant.id)}">Sepete ekle +</button>`:''}</div></div></article>`;
      }).join('')}<button class="light-guide__restart" type="button" data-guide-restart>Yanıtlarımı değiştir</button>`;
    }catch(err){
      console.warn('LumaSense guide catalog unavailable',err);
      body.innerHTML='<div class="light-guide__none">Ürün önerilerini şu anda yükleyemedik. Ürünlerimizi doğrudan inceleyerek size uygun seçeneği bulabilirsiniz.</div><a class="button" href="/collections/all">Tüm ürünleri gör</a><button class="light-guide__restart" type="button" data-guide-restart>Yeniden dene</button>';
    }
  }
  root.addEventListener('click',e=>{
    if(e.target.closest('[data-guide-open]')){if(panel.hidden){open();}else close();}
    if(e.target.closest('[data-guide-close]'))close();
    if(e.target.closest('[data-guide-start]'))start();
    if(e.target.closest('[data-guide-restart]'))start();
    if(e.target.closest('[data-guide-back]')){if(state.step===0)renderWelcome();else{state.step=Math.max(0,state.step-1);renderQuestion();}}
    if(e.target.closest('[data-guide-skip]')){if(state.step<questions.length-1){state.step++;renderQuestion();}else renderResults();}
    const answer=e.target.closest('[data-guide-answer]');
    if(answer){state.answers[questions[state.step].key]=answer.dataset.guideAnswer;if(state.step<questions.length-1){state.step++;renderQuestion();}else renderResults();}
    const add=e.target.closest('[data-guide-add]');
    if(add){add.disabled=true;add.textContent='Ekleniyor…';fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(add.dataset.guideAdd),quantity:1})}).then(r=>{if(!r.ok)throw new Error('add');panel.hidden=true;launcher.setAttribute('aria-expanded','false');window.LumaSenseOpenCart?.();}).catch(()=>{add.disabled=false;add.textContent='Tekrar dene';});}
  });
  document.addEventListener('keydown',e=>{if(e.key==='Escape'&&!panel.hidden)close();});
})();


// LumaSense Stripe sticky purchase bar (the checkout action is handled by the delegated buy-now handler below).
(()=>{
  const bar=document.querySelector('[data-strip-sticky]');
  const productSection=document.querySelector('[data-strip-product]');
  if(!bar||!productSection)return;
  if(!('IntersectionObserver' in window)){
    window.addEventListener('scroll',()=>bar.classList.toggle('is-visible',productSection.getBoundingClientRect().bottom<0),{passive:true});
    return;
  }
  const observer=new IntersectionObserver(entries=>{
    const entry=entries[0];
    bar.classList.toggle('is-visible',!entry.isIntersecting && entry.boundingClientRect.top<0);
  },{threshold:0.05});
  observer.observe(productSection);
})();

// Independent WhatsApp support assistant: a short topic selector before opening WhatsApp.
(()=>{
  const root=document.querySelector('[data-whatsapp-assistant]');
  if(!root)return;
  const launcher=root.querySelector('[data-wa-open]');
  const panel=root.querySelector('[data-wa-panel]');
  const close=root.querySelector('[data-wa-close]');
  const contact=root.querySelector('[data-wa-contact]');
  const topics=[...root.querySelectorAll('[data-wa-topic]')];
  const number=String(root.dataset.waNumber||'').replace(/\D/g,'');
  const baseMessage=root.dataset.waBaseMessage||'Merhaba, LumaSense hakkında destek almak istiyorum.';
  let selected='';
  const updateLink=()=>{
    if(!number){contact.removeAttribute('href');contact.setAttribute('aria-disabled','true');return;}
    const message=selected?`${baseMessage}\n\nKonu: ${selected}`:baseMessage;
    contact.href=`https://wa.me/${number}?text=${encodeURIComponent(message)}`;
  };
  const open=()=>{
    const guideRoot=document.querySelector('[data-light-guide]');
    const guidePanel=guideRoot?.querySelector('[data-guide-panel]');
    const guideLauncher=guideRoot?.querySelector('[data-guide-open]');
    if(guidePanel&&!guidePanel.hidden){guidePanel.hidden=true;guideLauncher?.setAttribute('aria-expanded','false');guideRoot.classList.remove('is-open');}
    panel.hidden=false;launcher.setAttribute('aria-expanded','true');
  };
  const shut=()=>{panel.hidden=true;launcher.setAttribute('aria-expanded','false');launcher.focus();};
  updateLink();
  launcher.addEventListener('click',()=>panel.hidden?open():shut());
  close?.addEventListener('click',shut);
  topics.forEach(button=>button.addEventListener('click',()=>{
    selected=button.dataset.waTopic||'';
    topics.forEach(item=>{const active=item===button;item.classList.toggle('is-selected',active);item.setAttribute('aria-pressed',String(active));});
    updateLink();
  }));
  document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden)shut();});
})();


// LumaSense Stripe: reliable muted autoplay, 3-for-2 bundle checkout, and contextual buy-now buttons.
(()=>{
  const productForm=document.querySelector('#StripProductForm');
  const sticky=document.querySelector('[data-strip-sticky]');
  const getVariantId=()=>{
    const field=productForm?.querySelector('[name="id"]');
    const id=Number(field?.value || document.querySelector('[data-strip-buy-now]')?.dataset.variantId || document.querySelector('[data-strip-promo-buy]')?.dataset.variantId || 0);
    return Number.isFinite(id)&&id>0?id:0;
  };
  const setStatus=(button,message)=>{
    const scope=button?.closest('.strip-promo-card,.strip-inline-buy,.strip-section-cta,.strip-sticky-buy')||button?.parentElement;
    const status=scope?.querySelector('[data-strip-promo-status],[data-strip-buy-status]');
    if(status)status.textContent=message;
  };
  const addAndCheckout=async(button,quantity)=>{
    if(!button||button.disabled)return;
    const id=getVariantId();
    if(!id){setStatus(button,'Ürün seçeneği bulunamadı. Lütfen sayfayı yenileyin.');return;}
    const original=button.textContent;
    button.disabled=true;
    button.textContent=quantity===3?'Kampanya hazırlanıyor…':'Yönlendiriliyor…';
    setStatus(button,'');
    try{
      let quantityToAdd=quantity;
      // If the customer already has this variant in the cart, top it up to three units instead of adding three more.
      if(quantity===3){
        const cartResponse=await fetch('/cart.js',{headers:{Accept:'application/json'}});
        if(cartResponse.ok){
          const cart=await cartResponse.json();
          const alreadyInCart=(cart.items||[]).filter(item=>Number(item.variant_id)===id).reduce((sum,item)=>sum+Number(item.quantity||0),0);
          quantityToAdd=Math.max(0,3-alreadyInCart);
        }
      }
      if(quantityToAdd>0){
        const response=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id,quantity:quantityToAdd})
        });
        const result=await response.json().catch(()=>({}));
        if(!response.ok)throw new Error(result.description||result.message||'Ürün sepete eklenemedi.');
      }
      window.location.assign('/checkout');
    }catch(error){
      console.error('LumaSense Stripe checkout:',error);
      button.disabled=false;
      button.textContent=original;
      setStatus(button,error.message||'Bir sorun oluştu. Lütfen yeniden deneyin.');
    }
  };
  document.addEventListener('click',event=>{
    const promo=event.target.closest('[data-strip-promo-buy]');
    if(promo){event.preventDefault();addAndCheckout(promo,3);return;}
    const buyNow=event.target.closest('[data-strip-buy-now]');
    if(buyNow){event.preventDefault();addAndCheckout(buyNow,1);}
  });

  // Recalculate visible campaign totals when a variant is selected.
  document.addEventListener('change',event=>{
    const select=event.target.closest('#StripProductForm [data-variant-select]');
    if(!select)return;
    const option=select.selectedOptions[0];
    const cents=Number(option?.dataset.priceCents||0);
    const currency=window.LumaSenseConfig?.currency||'TRY';
    const format=value=>new Intl.NumberFormat('tr-TR',{style:'currency',currency}).format(value/100);
    const normal=document.querySelector('[data-strip-promo-normal]');
    const deal=document.querySelector('[data-strip-promo-deal]');
    const saving=document.querySelector('[data-strip-promo-saving]');
    if(normal)normal.textContent=format(cents*3);
    if(deal)deal.textContent=format(cents*2);
    if(saving)saving.textContent=format(cents);
    document.querySelectorAll('[data-strip-buy-now],[data-strip-promo-buy]').forEach(button=>button.dataset.variantId=String(option?.value||''));
  });

  // Play muted videos only while visible; preserve the full frame on desktop and mobile.
  const videos=[...document.querySelectorAll('[data-strip-story-video]')];
  if(videos.length){
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if('IntersectionObserver' in window && !reducedMotion){
      const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
        const video=entry.target;
        if(entry.isIntersecting && entry.intersectionRatio>=0.35){
          video.muted=true;
          const play=video.play();
          if(play&&typeof play.catch==='function')play.catch(()=>{});
        }else{
          video.pause();
        }
      }),{threshold:[0,0.35,0.6]});
      videos.forEach(video=>observer.observe(video));
    }else{
      videos.forEach(video=>{video.controls=true;video.pause();});
    }
  }
})();
